export default __webpack_public_path__ + "static/10_V1@2x-f52b0c9d1534c7dd5b5cde7d22bacbd1.png";